import { makeStyles } from "@material-ui/core/styles";

// D8.6.1 — Estilos de CompaniesManagerImproved (extraídos del god file).
export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: theme.spacing(3),
  },
  // ✅ CORREGIDO: FormCard dinámico según tema
  formCard: {
    marginBottom: theme.spacing(3),
    borderRadius: theme.spacing(1),
    boxShadow: theme.mode === 'dark' ? "0 2px 8px rgba(0,0,0,0.3)" : "0 2px 8px rgba(0,0,0,0.1)",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
  },
  formCardContent: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
  },
  formTitle: {
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  formGrid: {
    marginTop: theme.spacing(2),
  },
  fieldContainer: {
    marginBottom: theme.spacing(2),
  },
  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.background.paper,
      borderRadius: theme.spacing(1),
      color: theme.palette.text.primary,
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&:hover": {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : "#fafafa",
      },
      "&.Mui-focused": {
        backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.background.paper,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
      fontWeight: "500",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
  },
  // ✅ CORREGIDO: SelectField dinámico según tema
  selectField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.background.paper,
      borderRadius: theme.spacing(1),
      color: theme.palette.text.primary,
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
      fontWeight: "500",
    },
    "& .MuiMenuItem-root": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      "&:hover": {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
      },
    },
  },
  buttonContainer: {
    display: "flex",
    gap: theme.spacing(2),
    justifyContent: "flex-end",
    marginTop: theme.spacing(3),
    flexWrap: "wrap",
  },
  actionButton: {
    borderRadius: theme.spacing(1),
    textTransform: "none",
    fontWeight: "600",
    padding: theme.spacing(1, 3),
    boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
    "&:hover": {
      boxShadow: "0 2px 6px rgba(0,0,0,0.16)",
    },
    transition: "all 0.2s ease",
  },
  primaryButton: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  secondaryButton: {
    backgroundColor: theme.palette.error.main,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
    },
  },
  clearButton: {
    backgroundColor: theme.palette.grey[500],
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.grey[600],
    },
  },
  // ✅ CORREGIDO: TableCard dinámico según tema
  tableCard: {
    borderRadius: theme.spacing(1),
    boxShadow: theme.mode === 'dark' ? "0 2px 8px rgba(0,0,0,0.3)" : "0 2px 8px rgba(0,0,0,0.1)",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
  },
  tableHeader: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    "& .MuiTableCell-head": {
      color: "white",
      fontWeight: "bold",
      fontSize: "0.95rem",
      borderBottom: "none",
    },
  },
  // ✅ CORREGIDO: TableRow dinámico según tema
  tableRow: {
    backgroundColor: theme.palette.background.paper,
    "&:hover": {
      backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.action.hover,
      cursor: "pointer",
    },
    transition: "background-color 0.2s ease",
  },
  // ✅ CORREGIDO: TableCell dinámico según tema
  tableCell: {
    borderBottom: `1px solid ${theme.mode === 'dark' ? '#4B5563' : 'rgba(224, 224, 224, 0.5)'}`,
    padding: theme.spacing(1.5),
    color: theme.palette.text.primary,
  },
  editButton: {
    color: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.2)' : "rgba(102, 126, 234, 0.1)",
    },
  },
  statusChip: {
    fontWeight: "600",
    borderRadius: theme.spacing(1),
  },
  statusActive: {
    backgroundColor: "#4CAF50",
    color: "white",
  },
  statusInactive: {
    backgroundColor: "#f44336",
    color: "white",
  },
  campaignsEnabled: {
    backgroundColor: "#2196F3",
    color: "white",
  },
  campaignsDisabled: {
    backgroundColor: "#757575",
    color: "white",
  },
  planChip: {
    backgroundColor: "#FF9800",
    color: "white",
    fontWeight: "600",
  },
  // ✅ CORREGIDO: WarningRow dinámico según tema
  warningRow: {
    backgroundColor: theme.mode === 'dark' ? '#78350f' : "#fff3cd",
    "&:hover": {
      backgroundColor: theme.mode === 'dark' ? '#92400e' : "#ffeaa7",
    },
  },
  // ✅ CORREGIDO: DangerRow dinámico según tema
  dangerRow: {
    backgroundColor: theme.mode === 'dark' ? '#7f1d1d' : "#f8d7da",
    "&:hover": {
      backgroundColor: theme.mode === 'dark' ? '#991b1b' : "#f5c6cb",
    },
  },
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  sectionTitle: {
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
}));
